const Introduction = () => {
  return (
    <div className='container mx-auto relative py-10 flex flex-col lg:flex-row gap-10 lg:gap-2 lg:items-end p-8 lg:h-[40svh]'>
      <h2 className="text-4xl lg:text-8xl font-montserrat font-semibold w-full text-purple-600 bg-gradient-to-r from-purple-500 to-indigo-500 text-transparent bg-clip-text">Explore our work</h2>
    </div>
  )
}

export default Introduction;
